import * as nob3 from './nob3'
import * as nob5 from './nob5'
import * as nob8 from './nob8'
import * as nob10 from './nob10'

export * as parser from './parser'

export {
  nob3,
  nob5,
  nob8,
  nob10,
}

export const basis = {
  A7: nob5,
  AF: nob5,
  BF: nob8,
  C2: nob3,
  T2: nob3,
  T5: nob5,
  M8: nob5,
}

export const methods = {
  fixed: '定位',
  fan: '番摊',
}

export const names = {
  A7: '新澳洲幸运5',
  AF: '澳洲幸运5',
  BF: '新澳洲幸运8番摊',
  C2: '加拿大PC28',
  T2: '台湾PC28',
  T5: '台灣五星彩',
  M8: '加拿大五星彩',
}

export const numbers = {
  A7: 5,
  AF: 5,
  BF: 8,
  C2: 3,
  T2: 3,
  T5: 5,
  M8: 5,
}

export const plays = {
  A7: ['fixed', 'fan'],
  AF: ['fixed', 'fan'],
  BF: ['fan'],
  C2: ['fixed', 'fan'],
  T2: ['fixed', 'fan'],
  T5: ['fixed', 'fan'],
  M8: ['fixed', 'fan'],
}
